{
  "version": 1,
  "asset_id": "076414b4-3259-4164-a3b4-56a933272bea",
  "project_id": "f9ca952a-2109-492f-a7b0-0345b2dfa2e1",
  "url": "/__l5e/assets-v1/076414b4-3259-4164-a3b4-56a933272bea/main-800.avif",
  "r2_key": "a/v1/f9ca952a-2109-492f-a7b0-0345b2dfa2e1/076414b4-3259-4164-a3b4-56a933272bea/main-800.avif",
  "original_filename": "main-800.avif",
  "size": 9648,
  "content_type": "image/avif",
  "created_at": "2026-07-17T19:12:03Z"
}
